import axios from "../axiosInstance";
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Sidebar from '../components/sidebar';
import Topbar from '../components/topbar';
import { errorMessage } from "../hooks/UserLogs";

export default function BillerDetails() {
    const { id } = useParams();
    const [invoice, setInvoice] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const bUrl = process.env.REACT_APP_B_URL;
    const [errMsg, setErrorMsg] = useState("Une erreure s'est produite!!");
    const [showError, setShowError] = useState(false);
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
        return new Date(dateString).toLocaleDateString(undefined, options)
    }

    const axiosInstance = axios.create({
              withCredentials: true,
            })

    const getInvoiceWalletDetails = async () => {

        const response = await axiosInstance.get(bUrl + "/biller-invoice/find-by-id?id=" + id).catch((err) => {
            if (err?.response?.status == 401 || err?.response?.status == 403) {
                setErrorMsg("Vous n'étes pas autorisé à faire cette opération (" + err?.response?.status + ")!!")
                setShowError(true);
            } else {
                let msg = errMsg + ' ' + err?.response?.status ? (err?.response?.status) : '';
                setErrorMsg(msg);
                setShowError(true);
            }
            console.error(err);

            setIsLoading(false)

        });
        if (response) {
            if (response?.data?.isError) {
                const msg = errorMessage(response?.data?.code)
                setErrorMsg(msg);
                setShowError(true);
            } else {
                setInvoice(response.data.body);
            }
        }
    }
    useEffect(() => {
        getInvoiceWalletDetails();
    }, [])
    return (
        <>
            <div className="">
                <Sidebar />
                <section className="home ">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                                <div><p className='fw-bold'>Transactions &gt; Facture</p></div>
                                <div><Topbar /></div>
                            </div>
                            <div className="table-content mt-2 p-4">
                                <div className="d-flex justify-content-center text">
                                    <div className='col-md-3 bg-primary'>
                                    </div>
                                    {invoice?.customerWallet?
                                        <div className='col-md-6 p-3'>
                                            <p className='fw-bold'>Client</p>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Prénom:</div>
                                                <div className='col-5 fw-bold'>{invoice?.customerWallet?.firstName}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Deuxiéme nom</div>
                                                <div className='col-5 fw-bold'>{invoice?.customerWallet?.middleName}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Nom</div>
                                                <div className='col-5 fw-bold'>{invoice?.customerWallet?.lastName}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Téléphone:</div>
                                                <div className='col-5 fw-bold'>{invoice?.customerWallet?.phone}</div>
                                            </div>
                                            <p className='fw-bold'>Transaction</p>

                                            
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Facture:</div>
                                                <div className='col-5 fw-bold'>{invoice.billerReference}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Code de recharge:</div>
                                                <div className='col-5 fw-bold'>{invoice.reloadBiller}</div>
                                            </div>

                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Frais:</div>
                                                <div className='col-5 fw-bold'>{invoice.feesAmount}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Status:</div>
                                                <div className='col-5 fw-bold'><sapan className="p-2" style={{background: invoice.invoiceStatus == 'P' ? "rgb(0,255,0,.3)" :(invoice.invoiceStatus == 'W'? "rgb(100,200,10,.1)":"rgb(255,0,0,.3)")}}>{invoice.invoiceStatus == 'P' ? 'Payée' : (invoice.invoiceStatus == 'W'? "En attente":"Echec")}</sapan></div>
                                            </div>
                                            {invoice.paymentModeObj != null ?
                                                <>
                                                    <div className='row mb-2 row-details'>
                                                        <div className='col-4'>Mode Paiement:</div>
                                                        <div className='col-5 fw-bold'>{invoice.paymentModeObj.description}</div>
                                                    </div>
                                                </>
                                                : ""}
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Total à payer:</div>
                                                <div className='col-5 fw-bold'>{invoice.amountToPaid}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Code:</div>
                                                <div className='col-5 fw-bold'>{invoice.invoiceCode}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-4'>Code de référence:</div>
                                                <div className='col-5 fw-bold'>{invoice.billerReference}</div>
                                            </div>

                                        </div>
                                        : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}
